import moment from 'moment';
import DatePickerConstants from '../../../../common/config/DatePickerConstants';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import { ENTERED_WIZARD } from '../../../common/redux/actions/types/SelectionCriteriaWizardActionTypes';
import {
  DATE_FIELD_SELECTED,
  DATE_PICKER_SELECTED,
  PERIOD_SELECTED_DAY,
  PERIOD_SELECTED_MONTH,
  PERIOD_SELECTED_WEEK,
  PERIOD_LAST_SELECTION,
} from '../actions/types/PeriodSelectionActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';
import { AUTH_LOGOUT } from '../../../../../components/application/redux/actions/types/authActionTypes';

const initialDayPickerState = {
  startDate: moment().endOf('day').toDate(),
  endDate: moment().endOf('day').toDate(),
};

const localStorageDateState = typeof localStorage !== 'undefined' && localStorage.getItem('dayPeriod') !== null ? JSON.parse(localStorage.getItem('dayPeriod')) : initialDayPickerState.startDate;

export const initialState = {
  startDate: moment(localStorageDateState.startDate),
  endDate: moment(localStorageDateState.endDate),
  datePicker: DatePickerConstants.DAY.value,
  dateField: '',
  weekPicker: {
    startDate: moment().startOf('isoWeek').toDate(),
    endDate: moment().endOf('isoWeek').toDate(),
  },
  monthPicker: {
    startDate: moment().startOf('month').toDate(),
    endDate: moment().endOf('month').toDate(),
  },
  dayPicker: initialDayPickerState,
  predefinedRange: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATE_FIELD_SELECTED:
      return {
        ...state, dateField: action.dateField,
      };
    case ENTERED_WIZARD: {
      const reportDefinition = ReportDefinitions[action.reportId];
      if (!reportDefinition) {
        return initialState;
      }
      const reportConstant = reportDefinition.periodSelection;
      const defaultRange = reportConstant.defaultRanges();
      const newState = {
        ...initialState,
        ...defaultRange,
        predefinedRange: reportConstant.predefinedRange,
        datePicker: reportConstant.defaultPicker.value,
      };
      // Current picker is the same as the previous one. Use picker from state
      if (state.datePicker === reportConstant.defaultPicker.value) {
        const currentPicker = DatePickerConstants[state.datePicker].name;
        newState[currentPicker] = state[currentPicker];
        newState.startDate = state.startDate;
        newState.endDate = state.endDate;
        newState.dateField = reportConstant.defaultDateType;
      }
      return newState;
    }
    case DATE_PICKER_SELECTED: {
      const { startDate, endDate } =
        state[DatePickerConstants[action.datePickerValue].name];
      return {
        ...state, datePicker: action.datePickerValue, startDate, endDate,
      };
    }
    case PERIOD_SELECTED_WEEK:
      return {
        ...state,
        startDate: action.startDate,
        endDate: action.endDate,
        weekPicker: {
          startDate: action.startDate,
          endDate: action.endDate,
        },
      };
    case PERIOD_SELECTED_MONTH:
      return {
        ...state,
        startDate: action.startDate,
        endDate: action.endDate,
        monthPicker: {
          startDate: action.startDate,
          endDate: action.endDate,
        },
      };
    case PERIOD_SELECTED_DAY:
      return {
        ...state,
        startDate: action.startDate,
        endDate: action.endDate,
        dayPicker: {
          startDate: action.startDate,
          endDate: action.endDate,
        },
      };
    case PERIOD_LAST_SELECTION:
      return {
        ...state,
        startDate: action.startDate.toDate(),
        endDate: action.endDate.toDate(),
        datePicker: action.datePicker,
      };
    case LOGGED_OUT:
      return initialState;
    case AUTH_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
